import { IconButton, makeStyles, Typography } from "@material-ui/core";
import * as React from "react";
import { Create, SimpleForm, TextInput, required, useNotify } from "react-admin";
import CloseIcon from "@material-ui/icons/Close";
import { RequestRedeliveryPutModel } from "../../Models/RequestServiceableRedeliveryModel";
import { useAuth } from "@airborne/react-admin";
import { RequestStatus } from "../../../../Enums/RequestStatus";
import { useAppDataProvider } from "../../../../../src/dataprovider";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: 40,
  },
  title: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "1em",
  },
  form: {
    [theme.breakpoints.up("xs")]: {
      width: 400,
    },
    [theme.breakpoints.down("xs")]: {
      width: "100vw",
      marginTop: -30,
    },
  },
  inlineField: {
    display: "inline-block",
    width: "50%",
  },
}));

const RequestServiceableRedeliveryRemark = ({ onClose, requestServiceableRedelivery, finalCallBack, ...props }) => {
  const { user } = useAuth();
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const requestId = requestServiceableRedelivery.requestId;

  const saveRemark = e => {
    let requestServiceableRedeliveryUpdateModel: RequestRedeliveryPutModel = new RequestRedeliveryPutModel();
    requestServiceableRedeliveryUpdateModel.id = requestServiceableRedelivery.id;
    requestServiceableRedeliveryUpdateModel.RequestId = requestId;
    requestServiceableRedeliveryUpdateModel.RedeliveryDate = requestServiceableRedelivery.redeliveryDate;
    requestServiceableRedeliveryUpdateModel.Status = RequestStatus.RequestRedeliveryRejected;
    requestServiceableRedeliveryUpdateModel.RedeliveryRemark = e.redeliveryRemark;
    requestServiceableRedeliveryUpdateModel.updatedBy = user?.employeeId;
    requestServiceableRedeliveryUpdateModel.updatedDate = new Date();

    dataProvider
      .putRequestServiceableRedelivery(requestServiceableRedeliveryUpdateModel)
      .then(result => {
        notify(`Record Updated`, "success", false, true);
        finalCallBack();
        onClose();
        history.push("/requestorders/" + requestId + "/4");
      })
      .catch(result => notify(`${result}`, "error", false, true));
  };

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.title}>
        <Typography variant="h6">CREATE REMARK</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <Create {...props}>
        <SimpleForm save={saveRemark}>
          <TextInput
            source="redeliveryRemark"
            label="Reject Remark"
            validate={required()}
            multiline
            resettable
            fullWidth
            rows={3}
            variant="outlined"
          />
        </SimpleForm>
      </Create>
    </div>
  );
};
export default RequestServiceableRedeliveryRemark;
